import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from 'react-redux';
import { IReportState, ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IBasicCenterListResponse, IAppState } from '@nkr/store/index';
import { ICenterBase, ICenter } from '@nkr/models/index';
import { IDashPwlLabBilling } from '@nkr/models/index';
import { IDashPwlLabBillingResponse } from '@nkr/store/reports';
import { OrganType } from '@nkr/enums/organ-type';
import Filter from './filter';
import Grid from './grid'
import PwlNav from '../nav';
import { Alert } from 'react-bootstrap';

interface BillingPayload {
    centerId: number,
    startDate: string,
    endDate: string,
    organType: number | null
}

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
    centerList: ICenter[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getPwlLabBillingData: (startDate: string, endDate: string, centerId: number, organType: number) => Promise<IDashPwlLabBillingResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    includeDash: boolean,
    includeNkr: boolean,
    centerList: ICenterBase[],
    labData: IDashPwlLabBilling[],
    centerId: number,
    startDate: string,
    endDate: string
}

const previousFirstDate = () => {
    var d = new Date();
    d.setDate(0); // set to last day of previous month
    d.setDate(1); // set to the first day of that month

    return d.toISOString().split('T')[0];
}

const previousEndDate = () => {
    var d = new Date();
    d.setDate(0); // set to last day of previous month
    return d.toISOString().split('T')[0];
}

class DashPWLLabBilling extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        includeDash: false,
        includeNkr: true,
        centerList: [],
        labData: [],
        startDate: previousFirstDate(),
        endDate: previousEndDate()
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI('sites[]=dash'));
        let cookies = new Cookies();
        cookies.remove("dashview", {path: '/'});

        let { centerId: centerNum } = this.props;

        let payload: BillingPayload = {
            centerId: centerNum !== null || centerNum > 0 ? centerNum : 0,
            startDate: parsed.startDate !== null && parsed.startDate !== undefined && parsed.endDate !== "" ? parsed.startDate : this.state.startDate,
            endDate: parsed.endDate !== null && parsed.endDate !== undefined && parsed.endDate !== "" ? parsed.endDate : this.state.endDate,
            organType: this.props.app.site.organType === OrganType.Liver ? OrganType.Liver : null
        }

        let { startDate, endDate, centerId, organType } = payload;

        this.props.showLoading('Getting report data, one moment please...').then(() => {
            Promise.all([
                this.props.getBasicCenterList(),
                this.props.getPwlLabBillingData(startDate, endDate, centerId, organType)
            ])
                .then(([centerListResponse, summaryVolumeResponse]) => {
                    let { results: centerList } = centerListResponse.data;
                    let { reportResults: labData } = summaryVolumeResponse.data.results;

                    this.setState({
                        centerList,
                        labData,
                        startDate,
                        endDate,
                        centerId
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                })
                .catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleFilter = () => {
        let { startDate, endDate, centerId } = this.state;

        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getPwlLabBillingData(startDate, endDate, centerId, this.props.app.site.organType)
                .then(summaryVolumeResponse => {
                    let { reportResults: labData } = summaryVolumeResponse.data.results;

                    this.setState({
                        labData,
                        centerId
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                })
                .catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleFilterChange = (startDate: string, endDate: string, centerId: number) => {
        this.setState({
            startDate,
            endDate,
            centerId
        });
    }

    setConversionUrl = () => {
        let { startDate, endDate } = this.state;

        let paramList = [];

        if (startDate !== null && startDate !== '' && startDate !== undefined) {
            paramList.push(encodeURI('startDate=' + startDate));
        }

        if (endDate !== null && endDate !== '' && startDate !== undefined) {
            paramList.push(encodeURI('endDate=' + endDate));
        } 

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/pwl-labbilling?' + params;

        window.history.pushState({}, '', newUrl);
    }

    render = () => {
        return (
            <>
                <PwlNav activeKey='LAB-BILLING' centerId={this.props.centerId} isAdmin={this.props.isAdmin} />

                <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5, marginBottom: 5 }}><strong>Please Note:</strong> Registrations where repeat-labs were ordered prior to March 14th, 2019 may not be accounted for.</Alert>

                <Filter
                    isAdmin={this.props.isAdmin}
                    centerId={this.state.centerId}
                    includeDash={this.state.includeDash}
                    includeNkr={this.state.includeNkr}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    centerList={this.state.centerList}
                    onFilterChange={this.handleFilterChange}
                    onFilter={this.handleFilter}
                />

                <Grid
                    labData={this.state.labData}
                    centerId={this.state.centerId}
                    isAdmin={this.props.isAdmin}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports,
        centerList: appState.centers.list,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getPwlLabBillingData: (startDate, endDate, centerId, organType) => {
            return dispatch(ReportActionCreators.getPwlLabBillingData(startDate, endDate, centerId, organType));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DashPWLLabBilling);